import PurposeSelect, {
  type PurposeOption,
} from "@/components/form/purpose-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is the whole purpose object**, not its id. */
export type PurposeFieldProps = PickerFieldProps<PurposeOption>;

export const PurposeField = makePickerField<PurposeOption>({
  name: "PurposeField",
  control: PurposeSelect,
  popout: true,
});
